import React from 'react';
import { Button, Space, Typography } from 'antd';
import UploadInsitu from './UploadInsitu';
import InsituTemplate from '../../../../../assets/validation/Template_InSitu.csv'

const { Title, Text } = Typography;

interface NoInSituDataComponentProps {
  name: string;
  longitude: number;
  latitude: number;
  source: string;
  onChangeToMatchInSitu: () => void;
  uploadRef: React.MutableRefObject<any>
  onUploadComplete: () => void
  disabledUpload: boolean
}

const NoInSituData: React.FC<NoInSituDataComponentProps> = ({
  name,
  longitude,
  latitude,
  source,
  onChangeToMatchInSitu,
  onUploadComplete,
  uploadRef,
  disabledUpload
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      gap: '20px',
      width: '100%',
      maxWidth: '600px',
      margin: '0 auto',
    }}>
      <Title level={4} style={{
        fontWeight: 'bold',
        marginBottom: 0,
        textAlign: 'center',
        width: '100%'
      }}>
        There is no in situ data available at this point
      </Title>

      <Space>
        <Button
          type="primary"
          onClick={onChangeToMatchInSitu}
          style={{borderRadius: 8, flex: 1}}
        >
          Change location to closest in situ station
        </Button>
        <UploadInsitu ref={uploadRef} onUploadComplete={onUploadComplete} disabled={disabledUpload} />

      </Space>

      <Space align='start'>
        <Space direction="vertical" size="small">
          <Text strong underline>Closest in situ station:</Text>
          <Text><Text strong>Name:</Text> {name}</Text>
          <Text><Text strong>Lon. [°E]:</Text> {longitude}</Text>
          <Text><Text strong>Lat. [°N]:</Text> {latitude}</Text>
          <Text><Text strong>Source:</Text> {source}</Text>
        </Space>
        <Space style={{width: 232, lineHeight: '1.5', marginLeft: 30}} align='start' direction='vertical'>
          <Text>
            Download the in situ{' '}
              <Button
                type='link'
                style={{ padding: 0 }}
                href={InsituTemplate}
                target='_blank'
                rel='noreferrer'
              >
                .csv
              </Button>
            {' '}template file, fill it in and upload it.
          </Text>
        </Space>
      </Space>
    </div>
  );
};

export default NoInSituData;
